﻿import $ from "jquery";
import { addCallback } from "./td";

// handle Select All | Select None
function initSelectCheckboxLinks(ctx) {
	$(".ui-checkboxchecker", ctx).on("click", "a", function (e) {
		e.preventDefault();
		var notifyQueue = {};
		var state = $(this).attr("href") === "#1";
		$("input[type=checkbox]:not(:disabled)", $(e.delegateTarget).parent()).each(function () {
			var check = $(this);
			if(check.prop("checked") != state) {
				var name = check.attr("name");
				if(notifyQueue[name])
					check.prop("checked", state);
				else
					notifyQueue[name] = check;
			}
		});
		// trigger click event for the last checkbox whose value was changed
		for(var k in notifyQueue)
			notifyQueue[k].click();
	});
}

addCallback(initSelectCheckboxLinks);

export { initSelectCheckboxLinks };